<body class="app">
  <app-header (eventFromHeader)="handleEvent($event)" [appVersion]="appVersion" [angularVersion]="angularVersion"></app-header>
  <div class="main-container">
    <app-sidebar></app-sidebar>
    <div class="content">
      <app-toast></app-toast>
      <app-main-content></app-main-content>  
    </div>
  </div>
</body>